import { render, staticRenderFns } from "./videoCallIcon.vue?vue&type=template&id=49e5c153&scoped=true"
import script from "./videoCallIcon.vue?vue&type=script&lang=js"
export * from "./videoCallIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e5c153",
  null
  
)

export default component.exports